import { ROLES } from '../../../constants/roles';
import { roleMatches } from '../../../utils/rolePermissions';

/**
 * Custom hook for AMP schedule permission checks
 */
export const useAMPSchedulePermissions = (user) => {
  const isOverride = [ROLES.ACCOUNTABLE_MANAGER, ROLES.SUPER_ADMIN].includes(user?.role);

  const canCreateAMPSchedule = [
    ROLES.CA_MANAGER,
    ROLES.CA_TECHNICAL_OFFICER, ROLES.CAMO_QM_MANAGER, ROLES.CAMO_QM_OFFICER, ROLES.PLANNING_MANAGER,
    ROLES.ACCOUNTABLE_MANAGER,
    ROLES.SUPER_ADMIN
  ].includes(user?.role);

  const canEditAMPSchedule = [
    ROLES.CA_MANAGER,
    ROLES.CA_TECHNICAL_OFFICER, ROLES.CAMO_QM_MANAGER, ROLES.CAMO_QM_OFFICER, ROLES.PLANNING_MANAGER,
    ROLES.ACCOUNTABLE_MANAGER,
    ROLES.SUPER_ADMIN
  ].includes(user?.role);

  const canDeleteAMPSchedule = [
    ROLES.CA_MANAGER,
    ROLES.CA_TECHNICAL_OFFICER, ROLES.CAMO_QM_MANAGER, ROLES.CAMO_QM_OFFICER, ROLES.PLANNING_MANAGER,
    ROLES.ACCOUNTABLE_MANAGER,
    ROLES.SUPER_ADMIN
  ].includes(user?.role);

  const canCreateWorkOrder = [
    ROLES.CA_MANAGER,
    ROLES.CA_TECHNICAL_OFFICER, ROLES.CAMO_QM_MANAGER, ROLES.CAMO_QM_OFFICER, ROLES.PLANNING_MANAGER,
    ROLES.ACCOUNTABLE_MANAGER,
    ROLES.SUPER_ADMIN
  ].includes(user?.role);

  const canViewAMPSchedules = roleMatches(user?.role, [
    ROLES.CA_MANAGER,
    ROLES.CA_TECHNICAL_OFFICER,
    ROLES.CAMO_QM_MANAGER,
    ROLES.CAMO_QM_OFFICER,
    ROLES.PLANNING_MANAGER,
    ROLES.STORE_INSPECTOR,
    ROLES.MRO_MANAGER,
    ROLES.MRO_ENGINEER,
    ROLES.MRO_QM_MANAGER,
    ROLES.MRO_QM_OFFICER,
    ROLES.ACCOUNTABLE_MANAGER,
    ROLES.SUPER_ADMIN
  ]);

  return {
    canCreateAMPSchedule,
    canEditAMPSchedule,
    canDeleteAMPSchedule,
    canCreateWorkOrder,
    canViewAMPSchedules,
    isOverride
  };
};
